interface FormatDurationToTimeObjectResponse {
  hours: number;
  minutes: number;
}

export function formatDurationToTimeObject(duration: number): FormatDurationToTimeObjectResponse {
  const hours = Math.floor(duration / (3600 * 1000));
  const minutes = Math.floor((duration % (3600 * 1000)) / 60000);
  return { hours, minutes };
}
